<template>
    <a
        href="#main-content"
        class="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-100 focus:rounded-lg focus:bg-white focus:px-4 focus:py-2 focus:text-sm focus:font-bold focus:text-slate-900 focus:shadow"
    >
        Skip to main content
    </a>

    <Topbar :appName="appName" />

    <main
        id="main-content"
        tabindex="-1"
    >
        <slot />
    </main>

    <Footer
        :appName="appName"
        :openCookieSettingsElementId="openCookieSettingsElementId"
    />
</template>

<script setup lang="ts">
    import Topbar from '@/Marketing/LandingPage/Component/LandingPage/Topbar.vue'
    import Footer from '@/Marketing/LandingPage/Component/LandingPage/Footer.vue'

    defineProps({
        appName: {
            type: String,
            required: true,
        },
        openCookieSettingsElementId: {
            type: String,
            required: true,
        },
    })
</script>
